import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

type Props = {
    value: string;
    label: string;
    error?: string;
    description?: string;
    type?: React.InputHTMLAttributes<unknown>['type'] | undefined;
    setValue: (newValue: string) => void;
};

export const OptimizationTaskField = ({ label, value, error, description, type='text', setValue }: Props) => {
    return (
        <Box>
            <TextField
                onChange={(event) => setValue(event.target.value)}
                label={label}
                value={value}
                error={!!error}
                helperText={error || description}
                fullWidth
                size='small'
                variant='outlined'
                type={type}
            />
        </Box>
    );
};
